import { RequestType } from "@internal/backstage-plugin-request-manager-common";

export const REQUEST_TYPE_LABEL_MAP: Record<RequestType, string> = {
    'domain-structure': 'Domain Structure',
    'component': 'Component',
    'resource': 'Resource',
    'product': 'Product',
};
